var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rightTop"},[_c('div',{staticClass:"title",style:(_vm.$route.params.dbcode != 1 ? 'border-bottom: 1px solid #08396A;' : 'border-bottom:none;')},[_c('span',[_vm._v(_vm._s(_vm.companyFullName))])]),_vm._v(" "),(_vm.$route.params.dbcode != 1)?_c('div',{staticClass:"con rightTop_companyList"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21987714","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rightTop.vue
// module id = null
// module chunks = 